import React, { Component } from 'react';
import { SupplierPopup } from "../../SupplierPopup/SupplierPopup";
import GoodsInPopup from '../../GoodsIn/GoodsInPopup';
import { ItemImage } from '../../ItemListing/ItemImage/ItemImage';
import { format } from "date-fns";

export class OrderSummaryListing extends Component {
    constructor(props) {
        super(props);
        this.state = { orderAmount: this.props.orderData.numberOutstanding };
        this.reduceOutstanding = this.reduceOutstanding.bind(this);
    };

    reduceOutstanding(amount) {
        this.setState({ orderAmount: Number(this.state.orderAmount) - Number(amount) });
    }

    render() {
        const order = this.props.orderData;
        const supplier = order.orderDetails?.supplier;
        const item = order.itemListing;
        const details = order.orderDetails;

        if (!(this.state.orderAmount > 0)) return null;

        const etaDate = order.estimatedArrivalDate ? new Date(order.estimatedArrivalDate) : null;
        const isOverdue = etaDate && etaDate < new Date();
        const isDueSoon = etaDate && !isOverdue && (etaDate - new Date() < 1000 * 60 * 60 * 24 * 2); // < 2 days

        // Card emphasis based on ETA
        const borderColor = isOverdue ? "#dc3545" : (isDueSoon ? "#fd7e14" : "lightgrey");
        const headerBadgeStyle = {
            display: "inline-block",
            padding: "2px 6px",
            borderRadius: "6px",
            background: isOverdue ? "#dc3545" : (isDueSoon ? "#fd7e14" : "#198754"),
            color: "white",
            marginLeft: "8px",
            fontSize: "0.85rem"
        };

        return (
            <div style={{ position: "relative", border: `2px solid ${borderColor}`, margin: "5px", padding: "8px", background: "#f9f9f9" }}>
                <div style={{ display: "flex", gap: "10px" }}>
                    <div style={{ width: "130px", textAlign: "left" }}>
                        <ItemImage imageId={item?.imageId} />
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ display: "flex", alignItems: "flex-start" }}>
                            <div style={{ flex: 1 }}>
                                <p className="item-large-heading" style={{ marginBottom: "4px" }}>
                                    {item?.name}
                                    <span style={headerBadgeStyle}>
                                        {isOverdue ? "Overdue" : (isDueSoon ? "Due soon" : "On track")}
                                    </span>
                                </p>
                                <p className="item-large-description" style={{ marginBottom: "6px" }}>
                                    Supplier:{" "}
                                    <SupplierPopup
                                        supplierData={supplier}
                                        triggerText={supplier?.name}
                                        showLink={true}
                                    />
                                    <span style={{ float: "right", textAlign: "right" }}>
                                        Ordered by: {order.orderedBy?.name}<br />
                                        <GoodsInPopup
                                            triggerText="Receive Goods"
                                            buttonVariant="outline-success"
                                            itemListingId={order.itemListingId}
                                            orderId={order.id}
                                            itemName={`${details?.modelName} / ${details?.supplierModelNumber}`}
                                            measurementUnit={item?.measurementUnit}
                                            itemDimensions={item?.measurementUnit === "Item" ? this.state.orderAmount : order.itemDimensions}
                                            onSubmit={this.reduceOutstanding}
                                        />
                                    </span>
                                </p>
                                <p className="item-large-description" style={{ marginBottom: "4px" }}>
                                    Quantity outstanding: <b>{this.state.orderAmount}</b>
                                    {" | "}
                                    ETA: <b>{etaDate ? format(etaDate, "dd MMM yyyy") : "N/A"}</b>
                                    {" | "}
                                    Order ID: <b>{order.id}</b>
                                </p>
                                <p className="item-large-description" style={{ marginBottom: "4px" }}>
                                    Part: <b>{details?.modelName}</b>
                                    {" | Supplier P/N: "}
                                    <b>{details?.supplierModelNumber}</b>
                                    {" | MFR P/N: "}
                                    <b>{details?.manufacturerModelNumber}</b>
                                </p>
                                {details?.url
                                    ? <p className="item-large-description" style={{ marginBottom: "0px" }}>
                                        Link: <a href={details.url} target="_blank" rel="noreferrer">{details.url}</a>
                                      </p>
                                    : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
